module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/alert-triangle-purple-620c7a6e702ca2bedb517eaa18323c15.svg";